import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["data-cy"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_radio_button = _resolveComponent("radio-button");
  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass(["radio-group-container", _ctx.$attrs['class'] || '']),
    "data-cy": _ctx.$attrs['data-cy'] || ''
  }, [_renderSlot(_ctx.$slots, "radio_element", {
    handleClick: _ctx.handleChange,
    activeValue: _ctx.selectedValue,
    reset: _ctx.reset,
    isActive: _ctx.isActive
  }, function () {
    return [_createCommentVNode("  Default Radio Buttons "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radioValues, function (radioValue, index) {
      var _a;
      return _openBlock(), _createBlock(_component_radio_button, {
        id: radioValue.id,
        key: index,
        label: radioValue.label,
        "is-checked": radioValue.label === ((_a = _ctx.selectedValue) === null || _a === void 0 ? void 0 : _a.label),
        onChange: _ctx.handleChange
      }, null, 8 /* PROPS */, ["id", "label", "is-checked", "onChange"]);
    }), 128 /* KEYED_FRAGMENT */))];
  })], 10 /* CLASS, PROPS */, _hoisted_1);
}